<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <BackButton :handler="gotoVenuePage" />
      </v-col>
      <v-col>
        <p class="text-center text-xl font-semibold text-blue">
          {{ editFlag ? "Update" : "Add" }} Venue
        </p>
      </v-col>
      <v-spacer />
    </v-row>
    <v-form ref="form" v-model="valid" v-on:submit.prevent>
      <v-row>
        <v-col cols="12" lg="8">
          <div class="shadow rounded-lg bordered p-4 bg-white mb-8">
            <div class="bg-neon-900 p-2 rounded-lg mb-4">
              <SvgIcon class="font-semibold" text="Venue Information">
                <template #icon>
                  <InformationIcon />
                </template>
              </SvgIcon>
            </div>
            <div class="d-flex gap-x-4">
              <div style="min-width: 220px; min-height: 220px">
                <ImageUploader
                  :height="200"
                  :image_path="venueForm.image_path"
                  default_image="default"
                  @upload="
                    (data) => {
                      venueForm.image = data;
                    }
                  "
                ></ImageUploader>
              </div>
              <v-row>
                <v-col class="py-0" cols="6">
                  <TextInput
                    v-model="venueForm.name"
                    :required="true"
                    :rules="nameRules"
                    label="Venue Name"
                  />
                </v-col>
                <v-col class="py-0" cols="6">
                  <TextInput
                    v-model="venueForm.ar_name"
                    label="اسم المكان باللغة العربية"
                    reverse
                  />
                </v-col>
                <v-col class="py-0" cols="6">
                  <label for=""> Phone Number </label>
                  <mobile-field
                    v-model="venueForm.phone"
                    class="q-text-field"
                    dense
                    hide-details="auto"
                    label=""
                  ></mobile-field>
                </v-col>
                <v-col class="py-0" cols="6">
                  <TextInput
                    v-model="venueForm.domain"
                    :required="true"
                    label="Domain"
                  />
                </v-col>
                <v-col class="py-0" cols="6">
                  <TextInput
                    v-model="venueForm.email"
                    :required="true"
                    :rules="[
                      (v) => !!v || 'E-mail is required',
                      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                    ]"
                    label="E-mail"
                  />
                </v-col>
                <v-col v-if="!editFlag" class="py-0" cols="6">
                  <label for=""> Password </label>
                  <v-text-field
                    v-model="venueForm.password"
                    :append-icon="viewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="viewPassword ? 'text' : 'password'"
                    class="q-text-field"
                    dense
                    hide-details="auto"
                    hint="At least 6 characters"
                    outlined
                    @click:append="viewPassword = !viewPassword"
                  ></v-text-field>
                </v-col>

                <v-col class="py-0" cols="6">
                  <TextInput
                    v-model="venueForm.contact_person_name"
                    label="Contact Person Name"
                  />
                </v-col>
              </v-row>
            </div>
            <v-row class="mt-4">
              <v-col cols="12" md="3">
                <TextInput
                  v-model="venueForm.code"
                  :required="true"
                  label="Vendor Code"
                />
              </v-col>
              <v-col cols="12" md="3">
                <label for=""> Subsidiary of </label>
                <v-select
                  v-model="venueForm.parent_venue_id"
                  :items="[{ id: null, name: 'None' }, ...venueList]"
                  class="q-autocomplete"
                  dense
                  hide-details="auto"
                  item-text="name"
                  item-value="id"
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <label for="">Select Country</label>
                <v-autocomplete
                  v-model="venueForm.country_id"
                  :items="countries"
                  :rules="[(v) => !!v || 'Country is required']"
                  class="q-autocomplete"
                  dense
                  hide-details="auto"
                  item-text="name"
                  item-value="id"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <label for="">Choose City</label>
                <v-autocomplete
                  v-model="venueForm.city_id"
                  :items="
                    cities.filter((x) => x.country_id == venueForm.country_id)
                  "
                  :rules="[(v) => !!v || 'City is required']"
                  class="q-autocomplete"
                  dense
                  hide-details="auto"
                  item-text="name"
                  item-value="id"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <FileInput
                  v-model="venueForm.trade_license_url"
                  :default-value="venueForm.trade_license"
                  :required="venue.id <= 0"
                  label="Trade License"
                />
              </v-col>
              <v-col cols="12" md="3">
                <FileInput
                  v-model="venueForm.tax_certificate_url"
                  :default-value="venueForm.tax_certificate"
                  :required="venue.id <= 0"
                  label="Tax Certificate"
                />
              </v-col>
              <v-col cols="12" md="3">
                <label for="">Max Allowed Users</label>
                <v-text-field
                  v-model="venueForm.max_allowed_users"
                  :rules="maxUsersRule"
                  background-color="#fff"
                  class="q-text-field"
                  dense
                  hide-details="auto"
                  outlined
                  suffix="Users"
                  type="number"
                ></v-text-field>
                <span class="text-xs" style="color: red"
                  >Note: 0 means unlimited</span
                >
              </v-col>
              <v-col cols="12" md="3">
                <label for="">Sales Person </label>
                <v-autocomplete
                  v-model="venueForm.sales_person_id"
                  :items="salesPersons"
                  class="q-autocomplete"
                  dense
                  hide-details="auto"
                  :item-text="getFullName"
                  item-value="sales_team_id"
                  outlined
                ></v-autocomplete>
              </v-col>
            </v-row>
          </div>
          <div class="shadow rounded-lg bordered p-4 bg-white mb-8">
            <div class="bg-neon-900 p-2 rounded-lg mb-2">
              <SvgIcon class="font-semibold" text="Agreement Details">
                <template #icon>
                  <AgreementIcon />
                </template>
              </SvgIcon>
            </div>
            <v-row>
              <v-col cols="12" md="4">
                <label for=""> Start date of agreement </label>
                <date-field
                  v-model="venueForm.agreement_start_date"
                  :back-fill="true"
                  :dense="true"
                  :rules="[(v) => !!v || 'Start date is required']"
                  class-name="q-text-field"
                  hide-details="auto"
                  label=""
                  outlined
                  required
                />
              </v-col>
              <v-col cols="12" md="4">
                <label for=""> Expiry Date </label>
                <date-field
                  v-model="venueForm.agreement_end_date"
                  :back-fill="false"
                  :dense="true"
                  :rules="[(v) => !!v || 'Expiry Date is required']"
                  class-name="q-text-field"
                  hide-details="auto"
                  label=""
                  outlined
                  required
                  :minDate="venueForm.agreement_start_date"
                />
              </v-col>
              <v-col cols="12" md="4">
                <FileInput
                  v-model="venueForm.agreement_file_url"
                  :default-value="venueForm.agreement_file"
                  :required="venue.id <= 0"
                  label="Agreement"
                />
              </v-col>
            </v-row>
          </div>
          <div class="shadow rounded-lg bordered p-4 bg-white mb-8">
            <div class="bg-neon-900 p-2 rounded-lg mb-2">
              <SvgIcon
                class="font-semibold"
                text="Transaction and System Settings"
              >
                <template #icon>
                  <TransactionIcon />
                </template>
              </SvgIcon>
            </div>
            <v-row>
              <v-col cols="12" md="4">
                <SelectInput
                  v-model="venueForm.qube_configuration"
                  :items="qube_config_options"
                  :required="true"
                  item-value="value"
                  item-text="name"
                  label="Qube Configuration"
                />
              </v-col>
              <v-col cols="12" md="4">
                <TextInput
                  v-model="venueForm.commission_pct"
                  :rules="commissionRules"
                  label="Rate % Per Transaction"
                  prefix="%"
                  type="number"
                />
              </v-col>

              <v-col cols="12" md="4">
                <TextInput
                  v-model="venueForm.commission_extra"
                  :rules="commissionRules"
                  label="Fee Per Transaction"
                  prefix="AED"
                  type="number"
                />
              </v-col>

              <v-col cols="12" lg="3" md="6">
                <TextInput
                  v-model="venueForm.marketing_email_limit"
                  :rules="numberRules"
                  label="Email Limit Per Month"
                  type="number"
                />
              </v-col>
              <v-col cols="12" lg="3" md="6">
                <TextInput
                  v-model="venueForm.marketing_sms_limit"
                  :rules="numberRules"
                  label="SMS Limit"
                  type="number"
                />
              </v-col>
              <v-col cols="12" lg="6">
                <label for=""> OTP Mode </label>
                <v-radio-group
                  v-model="venueForm.otp_mode"
                  class="mt-0 custom-radio-group"
                  row
                  :rules="[(v) => !!v || 'Choose a mode']"
                >
                  <v-radio
                    :ripple="false"
                    :value="1"
                    class="custom-radio"
                    color="cyan"
                    label="All"
                  />
                  <v-radio
                    :ripple="false"
                    :value="2"
                    class="custom-radio"
                    color="cyan"
                    label="SMS"
                  />
                  <v-radio
                    :ripple="false"
                    :value="3"
                    class="custom-radio"
                    color="cyan"
                    label="Email"
                  />
                  <v-radio
                    :ripple="false"
                    :value="4"
                    class="custom-radio"
                    color="cyan"
                    label="WhatsApp"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
          </div>
          <div
            class="shadow rounded-lg bordered p-4 bg-white mb-8"
            v-if="venueForm.enable_uae_pass === 1"
          >
            <div class="bg-neon-900 p-2 rounded-lg mb-2">
              <SvgIcon class="font-semibold" text="UAEPass keys">
                <template #icon>
                  <TransactionIcon />
                </template>
              </SvgIcon>
            </div>
            <v-row>
              <v-col cols="12" md="4">
                <TextInput
                  v-model="venueForm.uae_pass_web_client_id"
                  :rules="[(v) => !!v || 'Web client ID is required']"
                  label="Web Client ID"
                />
              </v-col>
              <v-col cols="12" md="4">
                <TextInput
                  v-model="venueForm.uae_pass_web_client_password"
                  :rules="[(v) => !!v || 'Web Client password is required']"
                  label="Web Client Password"
                />
              </v-col>
              <v-col cols="12" md="4">
                <TextInput
                  v-model="venueForm.uae_pass_web_scopes"
                  :rules="[(v) => !!v || 'Web scopes is required']"
                  label="Web Scopes"
                />
              </v-col>
              <v-col cols="12" md="4">
                <TextInput
                  v-model="venueForm.uae_pass_mobile_client_id"
                  :rules="[(v) => !!v || 'Mobile Client ID is required']"
                  label="Mobile Client ID"
                />
              </v-col>
              <v-col cols="12" md="4">
                <TextInput
                  v-model="venueForm.uae_pass_mobile_client_password"
                  :rules="[(v) => !!v || 'Mobile Client Password is required']"
                  label="Mobile Client Password"
                />
              </v-col>
              <v-col cols="12" md="4">
                <TextInput
                  v-model="venueForm.uae_pass_mobile_scopes"
                  :rules="[(v) => !!v || 'Mobile scopes is required']"
                  label="Mobile Scopes"
                />
              </v-col>
              <v-col cols="12" md="4">
                <TextInput
                  v-model="venueForm.uae_pass_callback_url"
                  :rules="[(v) => !!v || 'UAE-Pass callback url is required']"
                  label="UAE-Pass callback url"
                />
              </v-col>
            </v-row>
          </div>
          <div class="shadow rounded-lg bordered p-4 bg-white mb-8" v-if="venueForm.enable_sap === 1">
            <div class="bg-neon-900 p-2 rounded-lg mb-2">
              <SvgIcon class="font-semibold" text="SAP Integration">
                <template #icon>
                  <TransactionIcon/>
                </template>
              </SvgIcon>
            </div>
            <v-row>
              <v-col cols="12" md="4">
                <TextInput
                    v-model="venueForm.sap_client_id"
                    :rules="[(v) => !!v || 'SAP client id is required']"
                    label="SAP Client Id"
                />
              </v-col>
              <v-col cols="12" md="4">
                <TextInput
                    v-model="venueForm.sap_client_secret"
                    :rules="[(v) => !!v || 'SAP client secret is required']"
                    label="SAP client secret"
                />
              </v-col>
              <v-col cols="12" md="4">
                <TextInput
                    v-model="venueForm.sap_config_flag"
                    :rules="[(v) => !!v || 'SAP config flag is required']"
                    label="SAP config flag"
                />
              </v-col>
            </v-row>
          </div>
          <div
            class="shadow rounded-lg bordered p-4 bg-white mb-8"
            v-if="venueForm.enable_icp === 1 || venueForm.enable_cid === 1"
          >
            <div class="bg-neon-900 p-2 rounded-lg mb-2">
              <SvgIcon class="font-semibold" text="DCD setup">
                <template #icon>
                  <TransactionIcon />
                </template>
              </SvgIcon>
            </div>
            <v-row>
              <v-col cols="12" md="4">
                <TextInput
                  v-model="venueForm.dcd_auth_key"
                  :rules="[(v) => !!v || 'DCD Auth Key is required']"
                  label="DCD Auth Key"
                />
              </v-col>
            </v-row>
          </div>
          <div
            v-if="venueForm.custom_payment_gateway_enable === 1"
            class="shadow rounded-lg bordered p-4 bg-white mb-8"
          >
            <div class="bg-neon-900 p-2 rounded-lg mb-2">
              <SvgIcon class="font-semibold" text="Payment Gateways">
                <template #icon>
                  <PaymentGatewayIcon />
                </template>
              </SvgIcon>
            </div>
            <v-row class="ma-1">
              <v-col md="6">
                <v-radio-group
                  v-model="venueForm.custom_payment_gateway_type"
                  :rules="[(v) => !!v || 'Choose a type']"
                  class="mt-0 custom-radio-group"
                  dense
                  hide-details
                  row
                  @change="changePg"
                >
                  <v-radio
                    class="custom-radio"
                    color="cyan"
                    label="EPG"
                    value="EPG"
                  ></v-radio>
                  <v-radio
                    class="custom-radio"
                    color="cyan"
                    label="NPG"
                    value="NPG"
                  ></v-radio>
                  <v-radio
                    class="custom-radio"
                    color="cyan"
                    label="TELR"
                    value="TELR"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row
              v-if="venueForm.custom_payment_gateway_type === 'EPG'"
              :key="venueForm.custom_payment_gateway_type"
              class="ma-1"
            >
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_username"
                  :required="true"
                  label="Username"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_password"
                  :required="true"
                  label="Password"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_storeId"
                  :required="true"
                  label="Store ID"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_terminal"
                  :required="true"
                  label="Terminal"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_fab_merchant"
                  :required="true"
                  label="FAB Merchant"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_fab_url"
                  :required="true"
                  label="FAB URL"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <SelectInput
                  v-model="venueForm.custom_payment_gateway_status"
                  :items="statuses"
                  :required="true"
                  item-text="name"
                  item-value="id"
                  label="Select Status"
                />
              </v-col>
            </v-row>
            <v-row
              v-if="venueForm.custom_payment_gateway_type === 'NPG'"
              :key="venueForm.custom_payment_gateway_type"
              class="ma-1"
            >
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_api_key"
                  :required="true"
                  label="API key"
                />
              </v-col>

              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_outlet_reference"
                  :required="true"
                  label="Outlet Reference"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <SelectInput
                  v-model="venueForm.custom_payment_gateway_status"
                  :items="statuses"
                  :required="true"
                  item-text="name"
                  item-value="id"
                  label="Select Status"
                />
              </v-col>
            </v-row>
            <v-row
              v-if="venueForm.custom_payment_gateway_type === 'TELR'"
              :key="venueForm.custom_payment_gateway_type"
              class="ma-1"
            >
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_telr_store"
                  :required="true"
                  label="Store"
                  placeholder="Telr Store"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_telr_authkey"
                  :required="true"
                  label="AUTH KEY"
                  placeholder="Telr Auth Key"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_telr_remote_authkey"
                  :required="true"
                  label="REMOTE AUTH KEY"
                  placeholder="Telr Remote Auth Key"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.custom_payment_gateway_telr_api_key"
                  label="API KEY"
                  placeholder="Telr API Key"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <SelectInput
                  v-model="venueForm.custom_payment_gateway_status"
                  :items="statuses"
                  :required="true"
                  item-text="name"
                  item-value="id"
                  label="Select Status"
                />
              </v-col>
            </v-row>
          </div>
          <div
            v-if="venueForm.enable_dct_erp === 1"
            class="shadow rounded-lg bordered p-4 bg-white mb-8"
          >
            <div class="bg-neon-900 p-2 rounded-lg mb-2">
              <SvgIcon class="font-semibold" text="DCT ERP Details">
                <template #icon>
                  <ERPIcon />
                </template>
              </SvgIcon>
            </div>
            <v-row class="ma-1">
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.erp_app_url"
                  :required="true"
                  label="APP URL"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.erp_ocp_apim_subscription_key"
                  :required="true"
                  label="OCP APIM Subscription Key"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.erp_dct_user_id"
                  :required="true"
                  label="ERP User"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.erp_password"
                  :required="true"
                  label="DCT ERP Password"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.erp_grant_type"
                  :required="true"
                  label="Grant type"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.erp_default_customer_no"
                  :required="true"
                  label="Static customer number"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <SelectInput
                  v-model="venueForm.erp_service_code"
                  :items="service_codes"
                  :required="true"
                  item-text="name"
                  item-value="value"
                  label="Select Service Code"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <TextInput
                  v-model="venueForm.erp_project_no"
                  :required="true"
                  label="Project No"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <SelectInput
                  v-model="venueForm.erp_transaction_type"
                  :items="transaction_types"
                  :required="true"
                  item-text="name"
                  item-value="value"
                  label="Transaction Type"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <SelectInput
                  v-model="venueForm.erp_payment_account_id"
                  :items="payment_account_ids"
                  :required="true"
                  item-text="name"
                  item-value="value"
                  label="Payment Account Id"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <SelectInput
                  v-model="venueForm.erp_payment_method_ref"
                  :items="payment_method_ref"
                  :required="true"
                  item-text="name"
                  item-value="value"
                  label="Payment Method Reference"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <SelectInput
                  v-model="venueForm.erp_cash_receipt_type"
                  :items="cash_receipt_types"
                  :required="true"
                  item-text="name"
                  item-value="value"
                  label="Cash Receipt Type"
                />
              </v-col>
              <v-col cols="12" lg="3" md="4">
                <SelectInput
                  v-model="venueForm.erp_status"
                  :items="statuses"
                  :required="true"
                  item-text="name"
                  item-value="id"
                  label="Status"
                />
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" lg="4">
          <v-tabs
            class="mx-auto q-tabs w-full rounded-lg bg-white overflow-hidden"
            grow
            height="48"
            hide-slider
            icons-and-text
          >
            <v-tab href="#modules">
              <SvgIcon class="svg-stroke-icon" text="Module Subscription">
                <template #icon>
                  <ModulesIcon />
                </template>
              </SvgIcon>
            </v-tab>
            <v-tab href="#configurations">
              <SvgIcon class="svg-fill-icon" text="Configurations">
                <template #icon>
                  <ConfigurationsIcon />
                </template>
              </SvgIcon>
            </v-tab>

            <v-tab-item id="modules">
              <div class="p-4">
                <div class="d-flex justify-space-between align-center mb-2">
                  <label for=""> Search </label>
                  <v-checkbox
                    v-model="selectAll"
                    class="mb-1"
                    color="teal lighten-1 accent-4"
                    dense
                    hide-details="auto"
                    @change="submoduleSelection"
                  >
                    <template #label>
                      <p class="mb-1 text-sm">
                        {{ selectAll ? "Unselect All" : "Select all" }}
                      </p>
                    </template>
                  </v-checkbox>
                </div>

                <v-text-field
                  v-model="search"
                  background-color="#fff"
                  class="q-text-field"
                  dense
                  hide-details="auto"
                  outlined
                  placeholder="Search Modules"
                >
                  <template #prepend-inner>
                    <SearchIcon />
                  </template>
                </v-text-field>
                <div
                  class="overflow-y-auto mt-4 configuration-container"
                  style="max-height: 50vh"
                >
                  <v-expansion-panels v-model="panels" flat multiple>
                    <v-expansion-panel
                      v-for="(mod, index) in filteredModules"
                      :key="mod.id + '-' + index"
                      class="modules-panel mb-2"
                    >
                      <v-expansion-panel-header
                        class="bg-neon-900 d-flex justify-space-between w-full"
                        disable-icon-rotate
                        hide-actions
                      >
                        <p class="mb-0 text-base font-semibold">
                          {{ mod.module_name }}
                        </p>
                        <v-checkbox
                          :indeterminate="getCheckboxState(mod).indeterminate"
                          :ripple="false"
                          :value="getCheckboxState(mod).value"
                          class="m-0 w-fit"
                          color="teal lighten-1 accent-4"
                          dense
                          hide-details="auto"
                          style="max-width: fit-content"
                          @change="(val) => changeSubmoduleSelection(val, mod)"
                          @click.stop
                        ></v-checkbox>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-list shaped>
                          <v-list-item-group v-model="subModules" multiple>
                            <template v-for="(subMod, i) in mod.sub_modules">
                              <v-list-item
                                :key="`item-${i}`"
                                :ripple="false"
                                :value="subMod.id"
                                class="submodules"
                              >
                                <template v-slot:default="{ active }">
                                  <div
                                    :class="{
                                      'border-bottom':
                                        i !== mod.sub_modules.length - 1,
                                    }"
                                    class="d-flex justify-space-between align-center py-2 w-full"
                                  >
                                    <label
                                      :for="subMod.sub_module_name"
                                      class="text-sm"
                                    >
                                      {{ subMod.sub_module_name }}
                                    </label>
                                    <v-checkbox
                                      :input-value="active"
                                      :ripple="false"
                                      class="m-0 p-0"
                                      color="teal lighten-1 accent-4"
                                      dense
                                      hide-details
                                    ></v-checkbox>
                                  </div>
                                </template>
                              </v-list-item>
                            </template>
                          </v-list-item-group>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item id="configurations">
              <div class="bg-white p-4">
                <div
                  v-for="(checkbox, index) in checkboxes"
                  :key="checkbox.model"
                  :class="{ 'border-bottom': index !== checkboxes.length - 1 }"
                  class="d-flex justify-space-between align-center py-2"
                >
                  <label :for="checkbox.model" class="text-sm">
                    {{ checkbox.label }}
                  </label>
                  <v-checkbox
                    :id="checkbox.model"
                    v-model="venueForm[checkbox.model]"
                    :false-value="0"
                    :ripple="false"
                    :true-value="1"
                    class="m-0 p-0"
                    color="teal lighten-1 accent-4"
                    dense
                    hide-details
                    @change="
                      checkbox.changeEvent
                        ? handleCheckboxChange($event, checkbox.model)
                        : null
                    "
                  ></v-checkbox>
                </div>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row>
    </v-form>
    <v-row>
      <v-col cols="12" lg="8">
        <div class="d-flex justify-end align-center gap-x-4">
          <v-menu v-if="venueForm.id" content-class="q-menu" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :ripple="false"
                class="text_capitalize w-fit px-2 bg-blue opacity-10"
                elevation="0"
                height="48"
                outlined
                v-bind="attrs"
                v-on="on"
              >
                <DotsIcon />
                More options
              </v-btn>
            </template>
            <v-list>
              <v-list-item class="my-1" @click="changePasswordModel = true">
                <SvgIcon
                  class="font-medium text-sm gap-x-2"
                  text="Change Password"
                >
                  <template #icon>
                    <PasswordIcon />
                  </template>
                </SvgIcon>
              </v-list-item>
              <v-divider />
              <v-list-item class="my-1" @click="changeVenueStatus">
                <SvgIcon
                  :text="
                    (venueForm.status_id === 1 ? 'Deactivate' : 'Activate') +
                    ' Venue'
                  "
                  class="font-medium text-sm gap-x-2"
                >
                  <template #icon>
                    <ActivateIcon v-if="venueForm.status_id !== 1" />
                    <DeactivateIcon v-else />
                  </template>
                </SvgIcon>
              </v-list-item>
              <v-list-item class="my-1" @click="deleteConfirm(venueForm.id)">
                <SvgIcon
                  class="red--text font-medium text-sm gap-x-2"
                  text="Delete Venue"
                >
                  <template #icon>
                    <DeleteIcon opacity="1" stroke="red" />
                  </template>
                </SvgIcon>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            class="white--text blue-color"
            height="48"
            text
            @click="addUpdateVenue"
          >
            {{ editFlag ? "Update" : "Add" }} Venue
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <confirm-model
      v-bind="confirmModel"
      @close="confirmModel.id = null"
      @confirm="confirmActions"
    ></confirm-model>
    <ChangePassword
      :change-password-model="changePasswordModel"
      :venue-form="venueForm"
      @close="changePasswordModel = false"
    />
  </v-container>
</template>
<script>
import BackButton from "@/components/Buttons/BackButton.vue";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import InformationIcon from "@/assets/images/venues/information.svg";
import TransactionIcon from "@/assets/images/venues/transactions.svg";
import AgreementIcon from "@/assets/images/venues/agreement.svg";
import ModulesIcon from "@/assets/images/venues/modules.svg";
import ConfigurationsIcon from "@/assets/images/venues/configurations.svg";
import TextInput from "@/components/Fields/TextInput.vue";
import SelectInput from "@/components/Fields/SelectInput.vue";
import FileInput from "@/components/Fields/FileInput.vue";
import DotsIcon from "@/assets/images/venues/dots.svg";
import PasswordIcon from "@/assets/images/venues/password.svg";
import DeleteIcon from "@/assets/images/venues/delete-icon.svg";
import DeactivateIcon from "@/assets/images/venues/deactivate.svg";
import ActivateIcon from "@/assets/images/venues/activate.svg";
import ERPIcon from "@/assets/images/venues/erp.svg";
import SearchIcon from "@/assets/images/misc/search.svg";
import PaymentGatewayIcon from "@/assets/images/venues/payment-gateway.svg";
import ChangePassword from "@/components/Venues/ChangePassword.vue";
import ImageUploader from "@/components/Image/ImageUploader.vue";

export default {
  components: {
    ImageUploader,
    ChangePassword,
    FileInput,
    SelectInput,
    TextInput,
    SvgIcon,
    BackButton,
    InformationIcon,
    TransactionIcon,
    AgreementIcon,
    ModulesIcon,
    ConfigurationsIcon,
    DotsIcon,
    PasswordIcon,
    DeleteIcon,
    ActivateIcon,
    DeactivateIcon,
    ERPIcon,
    PaymentGatewayIcon,
    SearchIcon,
  },
  mounted() {
    this.getModules();
    this.getSalesTeam();
    if (this.$route.params.id) {
      this.getVenue(this.$route.params.id);
    }
    if (!this.$store.getters.getCountries.status) {
      this.$store.dispatch("loadCountries");
    }
    if (!this.$store.getters.getCities.status) {
      this.$store.dispatch("loadCities");
    }
    if (!this.$store.getters.getServices.status) {
      this.$store.dispatch("loadServices");
    }
    if (!this.$store.getters.getServices.status) {
      this.$store.dispatch("loadVenues");
    }
  },
  computed: {
    getCheckboxState() {
      return (mod) => {
        const allSelected = mod.sub_modules.every((subMod) =>
          this.subModules.includes(subMod.id)
        );
        const someSelected = mod.sub_modules.some((subMod) =>
          this.subModules.includes(subMod.id)
        );
        return {
          indeterminate:
            mod.sub_modules.length > 0 && someSelected && !allSelected,
          value: allSelected,
        };
      };
    },
    countries() {
      return this.$store.getters.getCountries.data;
    },
    cities() {
      return this.$store.getters.getCities.data;
    },
    services() {
      return this.$store.getters.getServices.data;
    },
    venueList() {
      if (this.venueForm.id) {
        return this.$store.getters.getVenues.data.filter(
          (item) => item.id !== this.venueForm.id
        );
      }
      return this.$store.getters.getVenues.data;
    },
    filteredModules() {
      return this.modules.filter((mod) =>
        mod.module_name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    checkboxes() {
      return [
        { model: "show_in_app", label: "Show in App" },
        // {model: "enable_order_seq", label: "Enable order sequence number"},
        // {model: "enable_email", label: "Enable order confirmation mail"},
        {
          model: "custom_payment_gateway_enable",
          label: "Enable Custom Payment Gateway",
          changeEvent: true,
        },
        { model: "enable_smtp", label: "Enable Custom SMTP" },
        { model: "enable_instagram", label: "Enable Instagram" },
        {
          model: "enable_custom_email",
          label: "Enable Custom Email templates",
        },
        { model: "enable_azure_ad_sso", label: "Enable Active Directory SSO" },
        { model: "enable_dct_erp", label: "Enable DCT ERP" },
        { model: "enable_sun_system", label: "Enable Sun System" },
        { model: "allow_child_sync", label: "Allow customers to sync" },
        {
          model: "enable_open_dated_tickets",
          label: "Allow Open dated tickets",
        },
        { model: "enable_split_payment", label: "Enable Split Payment" },
        { model: "enable_qpoints", label: "Enable QPoints" },
        {
          model: "enable_online_payment_report",
          label: "Enable Online Payment Report",
        },
        {
          model: "enable_icp",
          label: "Enable ICP",
        },
        {
          model: "enable_cid",
          label: "Enable CID Approval",
        },
        {
          model: "enable_uae_pass",
          label: "Enable UAEPass",
        },
        {
          model: "enable_sap",
          label: "Enable SAP Integration",
        },
      ];
    },
  },
  data() {
    return {
      panels: [],
      changePasswordModel: false,
      salesPersons: [],
      qube_config_options: [
        { name: "Generic", value: "generic" },
        { name: "AFH", value: "afh" },
        { name: "RM", value: "rm" },
        { name: "Golf", value: "golf" },
      ],
      venueForm: {
        erp_grant_type: "password",
        erp_cash_receipt_type: 1,
        erp_payment_method_ref: 3,
        erp_payment_account_id: 1,
        ar_name: "",
        name: "",
        otp_mode: 1,
        trade_license: null,
        tax_certificate: null,
        agreement_file: null,
        trade_license_url: null,
        tax_certificate_url: null,
        max_allowed_users: 0,
        agreement_file_url: null,
        agreement_start_date: null,
        agreement_end_date: null,
        enable_order_seq: 1,
        enable_email: 1,
        enable_sap: 0,
      },
      valid: true,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => (v && v.length >= 6) || "Min 6 characters",
      },
      nameRules: [(v) => !!v || "Name is required"],

      commissionRules: [
        (v) => !!v || v === 0 || "Field  is required",
        (value) => value >= 0 || "Minimum 0",
        (value) => value <= 100 || "Maximum 100",
      ],

      maxUsersRule: [
        (value) => value >= 0 || "Minimum 1",
        (value) => value <= 100 || "Maximum 100",
      ],

      numberRules: [
        (v) => !!v || v === 0 || "Limit is required",
        (v) => !isNaN(v) || "Limit should be a number",
      ],

      modules: [],
      subModules: [],
      venue: {},
      selectAll: false,
      service_codes: [
        {
          name: "DCT-AFT-ADMISSION-SITE-TICKETS",
          value: "DCT-AFT-ADMISSION-SITE-TICKETS",
        },
        { name: "DCT-ALAIN", value: "DCT-ALAIN" },
      ],
      transaction_types: [
        { name: "Abrahamic FH", value: "Abrahamic FH" },
        { name: "Al Murabba Fort", value: "Al Murabba Fort" },
        { name: "Qasr Al Muwaiji", value: "Qasr Al Muwaiji" },
        { name: "Aljahili Fort", value: "Aljahili Fort" },
        { name: "AAPM", value: "AAPM" },
        { name: "Beit Mohammed", value: "Beit Mohammed" },
        { name: "Jebel Hafit Desert Park", value: "Jebel Hafit Desert Park" },
        { name: "QAC", value: "QAC" },
        { name: "Handicrafts", value: "Handicrafts" },
      ],
      payment_account_ids: [{ name: "TCA ADCB Deposit Credit Card", value: 6 }],
      payment_method_ref: [{ name: "Credit Card", value: 3 }],
      cash_receipt_types: [{ name: "1 Cash", value: 1 }],
      editFlag: false,
      confirmModel: {
        id: null,
        title: null,
        description: null,
      },
      statuses: [
        { id: 1, name: "Active" },
        { id: 2, name: "Inactive" },
      ],
      search: "",
      viewPassword: false,
    };
  },
  methods: {
    getModules() {
      this.$http
        .get("/modules")
        .then((response) => {
          if (response.status == 200) {
            this.modules = response.data.data;
            this.panels = this.modules.map((mod, index) => index);
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },

    getSalesTeam() {
      let url = "sales-team/list";
      this.$http
        .get(url)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.salesPersons = response.data.data;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        })
        .finally(() => {});
    },
    getFullName(person) {
      return person.last_name
        ? `${person.first_name} ${person.last_name}`
        : person.first_name;
    },
    changePg() {
      this.$set(this.venueForm, "custom_payment_gateway_password", null);
      this.$set(this.venueForm, "custom_payment_gateway_username", null);
      this.$set(this.venueForm, "custom_payment_gateway_storeId", null);
      this.$set(this.venueForm, "custom_payment_gateway_terminal", null);
      this.$set(this.venueForm, "custom_payment_gateway_fab_url", null);
      this.$set(this.venueForm, "custom_payment_gateway_fab_merchant", null);
      this.$set(this.venueForm, "custom_payment_gateway_api_key", null);
      this.$set(
        this.venueForm,
        "custom_payment_gateway_outlet_reference",
        null
      );
      this.$set(this.venueForm, "custom_payment_gateway_status", null);
      this.$forceUpdate();
    },
    submoduleSelection(val) {
      if (val) {
        this.modules.forEach((mod) => {
          let subs = mod.sub_modules.map((item) => item.id);
          this.subModules.push(...subs);
        });
      } else {
        this.subModules = [];
      }
      this.$forceUpdate();
    },
    changeSubmoduleSelection(val, module) {
      let subs = module.sub_modules.map((item) => item.id);
      if (val) {
        this.subModules.push(...subs);
      } else {
        this.subModules = this.subModules.filter(
          (item) => !subs.includes(item)
        );
      }
    },
    getVenue(id) {
      if (typeof id != "undefined") {
        this.showLoader("Loading...");
        this.editFlag = true;
        this.$http
          .get("venues/" + id)
          .then((response) => {
            if (response.status == 200) {
              this.venueForm = response.data.data;
              if (
                this.venueForm.custom_payment_gateway_enable &&
                this.venueForm.payment_gateway
              ) {
                this.venueForm.custom_payment_gateway_type =
                  this.venueForm.payment_gateway.custom_payment_gateway_type;
                this.venueForm.custom_payment_gateway_fab_url =
                  this.venueForm.payment_gateway.custom_payment_gateway_fab_url;
                this.venueForm.custom_payment_gateway_fab_merchant =
                  this.venueForm.payment_gateway.custom_payment_gateway_fab_merchant;
                this.venueForm.custom_payment_gateway_username =
                  this.venueForm.payment_gateway.custom_payment_gateway_username;
                this.venueForm.custom_payment_gateway_password =
                  this.venueForm.payment_gateway.custom_payment_gateway_password;
                this.venueForm.custom_payment_gateway_storeId =
                  this.venueForm.payment_gateway.custom_payment_gateway_storeId;
                this.venueForm.custom_payment_gateway_terminal =
                  this.venueForm.payment_gateway.custom_payment_gateway_terminal;
                this.venueForm.custom_payment_gateway_api_key =
                  this.venueForm.payment_gateway.custom_payment_gateway_api_key;
                this.venueForm.custom_payment_gateway_outlet_reference =
                  this.venueForm.payment_gateway.custom_payment_gateway_outlet_reference;
                this.venueForm.custom_payment_gateway_status =
                  this.venueForm.payment_gateway.custom_payment_gateway_status;
                this.venueForm.custom_payment_gateway_telr_store =
                  this.venueForm.payment_gateway.TELR_STORE;
                this.venueForm.custom_payment_gateway_telr_authkey =
                  this.venueForm.payment_gateway.TELR_AUTH_KEY;
                this.venueForm.custom_payment_gateway_telr_remote_authkey =
                  this.venueForm.payment_gateway.TELR_REMOTE_AUTH_KEY;
                this.venueForm.custom_payment_gateway_telr_api_key =
                  this.venueForm.payment_gateway.TELR_API_KEY;
              }
              this.venueForm.show_in_app =
                this.venueForm.show_in_app.toString();
              this.venueForm.image_path = this.venueForm.profile_image;
              this.subModules = this.venueForm.subscriptions.map(
                (smod) => smod.sub_module_id
              );
              this.addVenueModel = true;
              let subCount = this.modules.reduce(
                (a, b) => a + parseFloat(b.sub_modules.length),
                0
              );

              this.selectAll = this.subModules.length === subCount;
              if (this.venueForm.enable_dct_erp === 1) {
                this.venueForm.erp_app_url =
                  this.venueForm.dct_erp_configuration.app_url;
                this.venueForm.erp_dct_user_id =
                  this.venueForm.dct_erp_configuration.dct_user_id;
                this.venueForm.erp_default_customer_no =
                  this.venueForm.dct_erp_configuration.default_customer_no;
                // this.venueForm.erp_gl_description = this.venueForm.dct_erp_configuration.gl_description;
                this.venueForm.erp_grant_type =
                  this.venueForm.dct_erp_configuration.grant_type;
                this.venueForm.erp_ocp_apim_subscription_key =
                  this.venueForm.dct_erp_configuration.ocp_apim_subscription_key;
                this.venueForm.erp_password =
                  this.venueForm.dct_erp_configuration.password;
                this.venueForm.erp_project_no =
                  this.venueForm.dct_erp_configuration.project_no;
                this.venueForm.erp_service_code =
                  this.venueForm.dct_erp_configuration.service_code;
                this.venueForm.erp_transaction_type =
                  this.venueForm.dct_erp_configuration.transaction_type;
                // this.venueForm.erp_task_name = this.venueForm.dct_erp_configuration.task_name;
                this.venueForm.erp_payment_account_id =
                  this.venueForm.dct_erp_configuration.payment_account_id;
                this.venueForm.erp_payment_method_ref =
                  this.venueForm.dct_erp_configuration.payment_method_ref;
                this.venueForm.erp_cash_receipt_type =
                  this.venueForm.dct_erp_configuration.cash_receipt_type;
                this.venueForm.erp_status =
                  this.venueForm.dct_erp_configuration.status_id;
              }
              if (this.venueForm.enable_icp || this.venueForm.enable_cid) {
                this.venueForm.dcd_auth_key =
                  this.venueForm.integrations.dcd_auth_key;
              }
              if (this.venueForm.enable_uae_pass) {
                this.venueForm.uae_pass_web_client_id =
                  this.venueForm.integrations.uae_pass_web_client_id;
                this.venueForm.uae_pass_web_client_password =
                  this.venueForm.integrations.uae_pass_web_client_password;
                this.venueForm.uae_pass_web_scopes =
                  this.venueForm.integrations.uae_pass_web_scopes;
                this.venueForm.uae_pass_mobile_client_id =
                  this.venueForm.integrations.uae_pass_mobile_client_id;
                this.venueForm.uae_pass_mobile_client_password =
                  this.venueForm.integrations.uae_pass_mobile_client_password;
                this.venueForm.uae_pass_mobile_scopes =
                  this.venueForm.integrations.uae_pass_mobile_scopes;
                this.venueForm.uae_pass_callback_url =
                  this.venueForm.integrations.uae_pass_callback_url;
              }
              if(this.venueForm.enable_sap){
                  this.venueForm.sap_config_flag = this.venueForm.integrations.sap_config_flag;
                  this.venueForm.sap_client_id = this.venueForm.integrations.sap_client_id;
                  this.venueForm.sap_client_secret = this.venueForm.integrations.sap_client_secret;
                }
                if (response.data.data.otp_mode) {
                this.venueForm.otp_mode = response.data.data.otp_mode;
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.errorChecker(error);
          })
          .finally(() => {
            this.hideLoader();
          });
      }
    },
    addUpdateVenue(event) {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.showError("Please complete all required fields");
        return;
      }
      if (this.subModules.length === 0) {
        this.showError("Please atleast one module to continue");
        return;
      }
      let formData = new FormData();
      formData.set("name", this.venueForm.name);
      formData.set("sub_module_ids", JSON.stringify(this.subModules));
      if (this.venueForm.password != null) {
        formData.set("password", this.venueForm.password);
      }
      if (this.venueForm.email != null) {
        formData.set("email", this.venueForm.email);
      }
      if (this.venueForm.image) {
        formData.set("image", this.venueForm.image);
      }
      formData.set("phone", this.venueForm.phone);
      formData.set("domain", this.venueForm.domain);
      if (this.venueForm.contact_person_name) {
        formData.set("contact_person_name", this.venueForm.contact_person_name);
      }
      if (this.venueForm.sales_person_id) {
        formData.set("sales_person_id", this.venueForm.sales_person_id);
      }
      formData.set("code", this.venueForm.code);
      formData.set("country_id", this.venueForm.country_id);
      formData.set("city_id", this.venueForm.city_id);
      if (this.venueForm.ar_name) {
        formData.set("ar_name", this.venueForm.ar_name);
      }
      // if (this.venueForm.ar_description) {
      //   formData.set("ar_description", this.venueForm.ar_description);
      // }
      formData.set("commission_pct", this.venueForm.commission_pct);
      formData.set("commission_extra", this.venueForm.commission_extra);
      formData.set(
        "marketing_email_limit",
        this.venueForm.marketing_email_limit
      );
      formData.set("marketing_sms_limit", this.venueForm.marketing_sms_limit);
      // if (this.venueForm.enable_order_seq) {
      formData.set("enable_order_seq", 1);
      // } else {
      //   formData.set("enable_order_seq", 0);
      // }
      // if (this.venueForm.enable_email) {
      formData.set("enable_email", 1);
      // } else {
      //   formData.set("enable_email", 0);
      // }
      formData.set("qube_configuration", this.venueForm.qube_configuration);

      // if (this.venueForm.enable_golf_mode) {
      // formData.set("enable_golf_mode", 1);
      // } else {
      formData.set("enable_golf_mode", 0);
      // }
      if (this.venueForm.enable_custom_email) {
        formData.set("enable_custom_email", 1);
      } else {
        formData.set("enable_custom_email", 0);
      }
      if (this.venueForm.enable_azure_ad_sso) {
        formData.set("enable_azure_ad_sso", 1);
      } else {
        formData.set("enable_azure_ad_sso", 0);
      }
      if (this.venueForm.enable_smtp) {
        formData.set("enable_smtp", 1);
      } else {
        formData.set("enable_smtp", 0);
      }
      if (this.venueForm.enable_instagram) {
        formData.set("enable_instagram", 1);
      } else {
        formData.set("enable_instagram", 0);
      }
      // if (this.venueForm.hide_customer_data) {
      // formData.set("hide_customer_data", 1);
      //} else {
      //formData.set("hide_customer_data", 0);
      //}

      // if (this.venueForm.description)
      //   formData.set("description", this.venueForm.description);
      formData.set("show_in_app", this.venueForm.show_in_app);
      if (this.venueForm.parent_venue_id != null) {
        formData.set("parent_venue_id", this.venueForm.parent_venue_id);
      }
      formData.set(
        "custom_payment_gateway_enable",
        this.venueForm.custom_payment_gateway_enable
      );
      formData.set("enable_uae_pass", this.venueForm.enable_uae_pass);
      if (this.venueForm.enable_uae_pass) {
        formData.set(
          "uae_pass_web_client_id",
          this.venueForm.uae_pass_web_client_id
        );
        formData.set(
          "uae_pass_web_client_password",
          this.venueForm.uae_pass_web_client_password
        );
        formData.set("uae_pass_web_scopes", this.venueForm.uae_pass_web_scopes);
        formData.set(
          "uae_pass_mobile_client_id",
          this.venueForm.uae_pass_mobile_client_id
        );
        formData.set(
          "uae_pass_mobile_client_password",
          this.venueForm.uae_pass_mobile_client_password
        );
        formData.set(
          "uae_pass_mobile_scopes",
          this.venueForm.uae_pass_mobile_scopes
        );
        formData.set(
          "uae_pass_callback_url",
          this.venueForm.uae_pass_callback_url
        );
      }
      formData.set("enable_icp", this.venueForm.enable_icp);
      formData.set(
        "uae_pass_callback_url",
        this.venueForm.uae_pass_callback_url
      );
      formData.set("enable_cid", this.venueForm.enable_cid);
      if (this.venueForm.enable_cid || this.venueForm.enable_icp) {
        formData.set("dcd_auth_key", this.venueForm.dcd_auth_key);
      }
      formData.set("enable_sap", this.venueForm.enable_sap);
      if (this.venueForm.enable_sap) {
        formData.set("sap_config_flag", this.venueForm.sap_config_flag);
        formData.set("sap_client_id", this.venueForm.sap_client_id);
        formData.set("sap_client_secret", this.venueForm.sap_client_secret);
      }

      if (this.venueForm.custom_payment_gateway_enable) {
        formData.set(
            "custom_payment_gateway_type",
            this.venueForm.custom_payment_gateway_type
        );
        if (this.venueForm.custom_payment_gateway_type === "EPG") {
          formData.set(
              "custom_payment_gateway_fab_url",
              this.venueForm.custom_payment_gateway_fab_url
          );
          formData.set(
              "custom_payment_gateway_fab_merchant",
              this.venueForm.custom_payment_gateway_fab_merchant
          );
          formData.set(
              "custom_payment_gateway_username",
              this.venueForm.custom_payment_gateway_username
          );

          formData.set(
              "custom_payment_gateway_password",
              this.venueForm.custom_payment_gateway_password
          );

          formData.set(
              "custom_payment_gateway_storeId",
              this.venueForm.custom_payment_gateway_storeId
          );

          formData.set(
              "custom_payment_gateway_terminal",
              this.venueForm.custom_payment_gateway_terminal
          );
        } else if (this.venueForm.custom_payment_gateway_type === "NPG") {
          formData.set("custom_payment_gateway_api_key", this.venueForm.custom_payment_gateway_api_key);
          formData.set("custom_payment_gateway_outlet_reference", this.venueForm.custom_payment_gateway_outlet_reference);
        }else if (this.venueForm.custom_payment_gateway_type === "TELR") {
          formData.set("TELR_STORE", this.venueForm.custom_payment_gateway_telr_store);
          formData.set("TELR_AUTH_KEY", this.venueForm.custom_payment_gateway_telr_authkey);
          formData.set("TELR_REMOTE_AUTH_KEY", this.venueForm.custom_payment_gateway_telr_remote_authkey);
          formData.set("TELR_API_KEY", this.venueForm.custom_payment_gateway_api_key);
        }
        formData.set(
          "custom_payment_gateway_status",
          this.venueForm.custom_payment_gateway_status
        );
      }

      if (this.venueForm.allow_child_sync) {
        formData.set("allow_child_sync", 1);
      } else {
        formData.set("allow_child_sync", 0);
      }

      if (this.venueForm.enable_open_dated_tickets) {
        formData.set("enable_open_dated_tickets", 1);
      } else {
        formData.set("enable_open_dated_tickets", 0);
      }

      if (this.venueForm.enable_split_payment) {
        formData.set("enable_split_payment", 1);
      } else {
        formData.set("enable_split_payment", 0);
      }

      if (this.venueForm.enable_qpoints) {
        formData.set("enable_qpoints", 1);
      } else {
        formData.set("enable_qpoints", 0);
      }

      if (this.venueForm.enable_online_payment_report) {
        formData.set("enable_online_payment_report", 1);
      } else {
        formData.set("enable_online_payment_report", 0);
      }

      /** DCT ERP configuration */
      if (this.venueForm.enable_dct_erp) {
        formData.set("enable_dct_erp", 1);
      } else {
        formData.set("enable_dct_erp", 0);
      }
      if (this.venueForm.enable_dct_erp) {
        formData.set("erp_app_url", this.venueForm.erp_app_url);
        formData.set("erp_dct_user_id", this.venueForm.erp_dct_user_id);
        formData.set("erp_password", this.venueForm.erp_password);
        formData.set("erp_grant_type", this.venueForm.erp_grant_type);
        formData.set("erp_service_code", this.venueForm.erp_service_code);
        formData.set("erp_project_no", this.venueForm.erp_project_no);
        formData.set(
          "erp_transaction_type",
          this.venueForm.erp_transaction_type
        );
        // formData.set("erp_task_name", this.venueForm.erp_task_name);
        // formData.set("erp_gl_description", this.venueForm.erp_gl_description);
        formData.set(
          "erp_default_customer_no",
          this.venueForm.erp_default_customer_no
        );
        formData.set(
          "erp_ocp_apim_subscription_key",
          this.venueForm.erp_ocp_apim_subscription_key
        );
        formData.set(
          "erp_payment_account_id",
          this.venueForm.erp_payment_account_id
        );
        formData.set(
          "erp_payment_method_ref",
          this.venueForm.erp_payment_method_ref
        );
        formData.set(
          "erp_cash_receipt_type",
          this.venueForm.erp_cash_receipt_type
        );
        formData.set("erp_status", this.venueForm.erp_status);
      }
      if (this.venueForm.enable_sun_system) {
        formData.set("enable_sun_system", 1);
      } else {
        formData.set("enable_sun_system", 0);
      }
      if (this.venueForm.otp_mode) {
        formData.set("otp_mode", this.venueForm.otp_mode);
      }
      formData.set("agreement_file", this.venueForm.agreement_file_url);
      formData.set("trade_license", this.venueForm.trade_license_url);
      formData.set("tax_certificate", this.venueForm.tax_certificate_url);
      formData.set("max_allowed_users", this.venueForm.max_allowed_users);
      formData.set("agreement_start_date", this.venueForm.agreement_start_date);
      formData.set("agreement_end_date", this.venueForm.agreement_end_date);
      this.showLoader("Verifying and saving credentials");
      this.$http({
        url: "venues" + (this.venueForm.id ? `/${this.venueForm.id}` : ""),
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data; boundary=${form._boundary}",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.showSuccess("Venue Saved Successfully.");
            this.gotoVenuePage();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        })
        .finally(() => {
          this.hideLoader();
        });
    },
    changeVenueStatus() {
      this.showLoader("Please Wait");
      this.$http
        .put(`venues/${this.venueForm.id}/status`)
        .then((response) => {
          if (response.status === 200) {
            this.showSuccess(
              `Venue ${
                this.venueForm.status_id !== 1 ? "activated" : "deactivated"
              } successfully`
            );
            this.getVenue(this.venueForm.id);
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        })
        .finally(() => {
          this.hideLoader();
        });
    },
    gotoVenuePage() {
      this.$router.push({ name: "Venues" });
    },
    deleteConfirm(venue_id) {
      this.confirmModel = {
        id: venue_id,
        title: "Do you want to delete this venue?",
        description:
          "By clicking <b>Yes</b> you can confirm the operation.  Do you need to continue your action ?",
        type: "delete_venue",
      };
    },
    confirmActions(data) {
      if (data.type == "delete_venue" && data.id) {
        this.deleteVenue(data.id);
      }
      this.confirmModel.id = null;
    },
    deleteVenue(venue_id) {
      this.showLoader("Please Wait");

      this.$http
        .put(`venues/${venue_id}/delete`)
        .then((response) => {
          this.hideLoader();
          if (response.status == 200) {
            this.showSuccess(`Venue deleted successfully`);
            this.gotoVenuePage();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    handleCheckboxChange(val, model) {
      this.venueForm[model] = val;
      if (model === "custom_payment_gateway_enable") {
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.submodules {
  padding: 0;

  &.v-list-item--link::before {
    background: transparent !important;
  }
}

.q-tabs {
  position: sticky;
  top: 75px;
}
</style>
<style lang="scss">
.modules-panel {
  margin-top: 0 !important;

  .v-expansion-panel-content__wrap {
    padding-left: 8px;
    padding-right: 0;
    padding-bottom: 0;
  }

  .v-expansion-panel-header {
    min-height: 48px !important;
    padding: 8px;
  }
}

.configuration-container {
  @media screen and (min-width: 1264px) {
    max-width: 26vw;
  }
}
</style>
